












import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InuptCCNumber extends Vue {

  @Prop()
  placeholder!: string;

  public label = 'Digite su número de documento';
  public icon = 'sensor_window';
  public error = '';


  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'Cedula invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
